import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-gold/60 bg-soft py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-21" data-mp="1ao7cfakxsxfl">
        <SectionHeading id="bonus-title" data-id="element-22" data-mp="1aoywbo5696q1">The {totalBonuses} <span className="text-accent" data-id="element-23" data-mp="15pmczddiehs7">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-gold/70 bg-surface shadow-glow" data-id="element-24" data-mp="15njcfzeqd698">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-primary/25 p-5 last:border-b-0 sm:p-6" data-id="element-25" data-mp="1eny2fc2n39j2" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gold text-gold-foreground shadow-glow-gold" data-id="element-26" data-mp="2ji60xuacvvgw">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-27" data-mp="2ogg1kkeuno9w" />
                </span>
                <div data-id="element-28" data-mp="1quimyy3lc338">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-primary-strong" data-id="element-29" data-mp="1qv1tlinsj51y">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-bold leading-tight text-foreground" data-id="element-30" data-mp="20remwfffbgw6">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-31" data-mp="25qhua6ivlz7b">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-surface px-6 py-6 text-center shadow-glow-gold sm:flex-row sm:text-left" data-id="element-32" data-mp="3c6acgwflz2ri">
          <div data-id="element-33" data-mp="1h1u4rqquva3k">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-34" data-mp="1h5i0mwjrw8lg">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-primary decoration-2" data-id="element-35" data-mp="1q43e4dae0xfd">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-36" data-mp="1m0nklptm7d6w">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-37" data-mp="yc4engy1fchz">Your price today</p>
            <p className="mt-2 inline-flex items-center gap-2 rounded-xl bg-gold px-4 py-1.5 text-3xl font-extrabold tracking-tight text-gold-foreground" data-id="element-38" data-mp="tem3rl0gmn7c">
              <GiftIcon className="h-6 w-6" aria-hidden="true" data-id="element-39" data-mp="1772b2y0e97e2" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}